import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Box,
  Typography,
} from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';

interface BulkInactivateDialogProps {
  open: boolean;
  loading: boolean;
  selectedCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export const BulkInactivateDialog: React.FC<BulkInactivateDialogProps> = ({
  open,
  loading,
  selectedCount,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={!loading ? onCancel : undefined}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Toplu Stok Pasife Alma</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Box component="span" sx={{ fontWeight: 'bold', color: 'error.main' }}>
            DİKKAT:
          </Box> Bu işlem geri alınamaz. Seçili {selectedCount} adet stok ürünü kalıcı olarak pasife alınacaktır.
        </DialogContentText>
        <Box sx={{ mt: 2, p: 2, bgcolor: 'background.paper', border: '1px solid #ddd', borderRadius: 1 }}>
          <Typography variant="subtitle2" gutterBottom>
            Pasife Alma İşlemi Detayları:
          </Typography>
          <Typography variant="body2">
            • Toplam pasife alınacak ürün sayısı: {selectedCount}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Pasif olan ürünler tüm depolardan kaldırılacak ve ilgili tüm veriler silinecektir.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onCancel} 
          color="primary"
          disabled={loading}
        >
          İptal
        </Button>
        <Button 
          onClick={onConfirm} 
          color="error" 
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={24} color="inherit" /> : <BlockIcon />}
        >
          {loading ? 'Pasife Alınıyor...' : `${selectedCount} Ürünü Pasife Al`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

